import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from 'src/utils/base-query.js'

// Define a service using a base URL and expected endpoints
export const toolApi = createApi({
  reducerPath: 'toolApi',
  tagTypes: ['Tool'],
  baseQuery,
  endpoints: (builder) => ({
    cnameLookUp: builder.mutation({
      query: (data) => {
        return {
          url: 'tools/cname_lookup',
          method: 'POST',
          body: data
        }
      }
    }),
    spfLookUp: builder.mutation({
      query: (data) => {
        return {
          url: 'tools/spf_checker',
          method: 'POST',
          body: data
        }
      }
    }),
    dmarkLookUp: builder.mutation({
      query: (data) => {
        return {
          url: 'tools/dmarc_checker',
          method: 'POST',
          body: data
        }
      }
    }),
    SSLLookUp: builder.mutation({
      query: (data) => {
        return {
          url: 'tools/ssl_checker',
          method: 'POST',
          body: data
        }
      }
    }),
    dkimLookUp: builder.mutation({
      query: (data) => {
        return {
          url: 'tools/dkim_checker',
          method: 'POST',
          body: data
        }
      }

    }),
    dkimGenerator: builder.mutation({
      query: (data) => {
        return {
          url: 'tools/dkim_generator',
          method: 'POST',
          body: data
        }
      }
    }),
    domainIpBlockList: builder.mutation({
      query: (data) => {
        return {
          url: 'tools/domain_blacklist_checker',
          method: 'POST',
          body: data
        }
      }
    }),
    spfRecordGenerator: builder.mutation({
      query: (data) => {
        return {
          url: 'tools/spf_generator',
          method: 'POST',
          body: data
        }
      }
    }),
    dmarkRecordGenerator: builder.mutation({
      query: (data) => {
        return {
          url: 'tools/dmarc_generator',
          method: 'POST',
          body: data
        }
      }
    }),
    emailVerification: builder.mutation({
      query: (data) => {
        return {
          url: 'tools/email_verifier',
          method: 'POST',
          body: data
        }
      }
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCnameLookUpMutation,
  useSpfLookUpMutation,
  useDmarkLookUpMutation,
  useSSLLookUpMutation,
  useDkimLookUpMutation,
  useDkimGeneratorMutation,
  useDomainIpBlockListMutation,
  useSpfRecordGeneratorMutation,
  useDmarkRecordGeneratorMutation,
  useEmailVerificationMutation
} = toolApi
